import React, { useState } from "react";
import "../../CSS/Footer.css";
import { Layout, Button } from "antd";
import Header from "../layout/HeaderComponent";
import moment from "moment";
import { routes } from "../../util/constant";
import { useLocation } from "react-router-dom";
import {
  AuthenticatedTemplate,
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { msalConfig } from "../../authConfig";
import { InteractionType } from "@azure/msal-browser";
import HomePage from "../pages/HomePage";
import NodePage from "../pages/NodePage";
import PageNotFound from "../pages/PageNotFound";
import Search from "../pages/Search";
const { Sider, Content, Footer } = Layout;
export default function AdminDashboard(props) {
  const { instance } = useMsal();
  const [collapsed, setCollapsed] = useState(false);
  const [sideCollapsed, setSideCollapsed] = useState(false);
  const [viewToggleBtn, setViewToggleBtn] = useState(true);
  const location = useLocation();

  //   const toggle = () => {
  //     setCollapsed(!collapsed);

  //     setSideCollapsed(false);
  //   };

  const { pathname } = props.location;
  function renderPathName(pathname) {
    if (pathname.startsWith("/node")) {
      return <NodePage location={location} />;
    }
    switch (pathname) {
      case routes.HOME:
        return <HomePage location={location} />;
      case routes.SEARCH:
        return <Search location={location} />;
      default:
        return <PageNotFound location={location} />;
    }
  }

  return (
    <>
      {/* <Layout> */}
      <Layout>
        <Header
          location={location}
          user={instance.getActiveAccount()}
          signOut={props.signOut}
        />
        <Content
          style={{
            padding: "68px 0px 10px 0px",
            minHeight: "100vh",
          }}
        >
          {renderPathName(pathname)}
        </Content>

        <Footer
          className="text-center"
          style={{
            padding: "15px 30px",
            background: "#005BA1",
            opacity: 1,
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="font-roboto text-lg text-white">
              ©{moment().year()} YASH DevXOps Competency. All Rights Reserved.
            </div>
            <div className="font-roboto text-lg text-white">
              Follow us on LinkedIn | Twitter
            </div>
          </div>
        </Footer>
      </Layout>
      {/* </Layout> */}
    </>
  );
}
